"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogActionReturnValue = exports.DialogAction = void 0;
function DialogAction(options) {
    return function (target, propertyKey, _) {
        if (!target.dialogActions) {
            target.dialogActions = [];
        }
        const actionDescriptor = {
            close: options.close,
            fn: target[propertyKey],
            keepOpenOnResolve: options.keepOpenOnResolve,
            label: options.label,
            passErrors: options.passErrors,
            style: options.style,
            visibleWhen: options.visibleWhen
        };
        target.dialogActions.push(actionDescriptor);
    };
}
exports.DialogAction = DialogAction;
var DialogActionReturnValue;
(function (DialogActionReturnValue) {
    DialogActionReturnValue["REBOUND"] = "_REBOUND_";
})(DialogActionReturnValue = exports.DialogActionReturnValue || (exports.DialogActionReturnValue = {}));
//# sourceMappingURL=DialogAction.js.map